import { motion } from "framer-motion";
import { Users, BadgeIndianRupee, FileSignature, HardHat, Warehouse, Briefcase, Calculator } from "lucide-react";

const services = [
  {
    icon: BadgeIndianRupee,
    title: "Salary-Based Hiring",
    desc: "Our core focus — long-term workforce on structured payroll for maximum reliability and value.",
    span: "sm:col-span-2",
    featured: true,
    testid: "service-card-1",
  },
  {
    icon: Users,
    title: "Permanent Recruitment & Staffing",
    desc: "Full-time hires matched to your operations.",
    span: "",
    testid: "service-card-2",
  },
  {
    icon: FileSignature,
    title: "Contract & Temporary Staffing",
    desc: "Flexible manpower for seasonal peaks.",
    span: "",
    testid: "service-card-3",
  },
  {
    icon: Warehouse,
    title: "Warehouse & Logistics Staff",
    desc: "Sorters, packers, loaders and hub staff.",
    span: "",
    testid: "service-card-4",
  },
  {
    icon: HardHat,
    title: "Skilled & Unskilled Manpower",
    desc: "Vetted workers across every grade.",
    span: "",
    testid: "service-card-5",
  },
  {
    icon: Briefcase,
    title: "Office & Administrative Staff",
    desc: "Back-office and admin hiring support.",
    span: "",
    testid: "service-card-6",
  },
  {
    icon: Calculator,
    title: "Payroll & HR Support",
    desc: "Compliance, attendance and payroll handled end-to-end.",
    span: "sm:col-span-2",
    testid: "service-card-7",
  },
];

export const Services = () => (
  <section id="services" className="relative bg-[#0a0f1d] py-20 sm:py-28">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-12 sm:mb-16 max-w-2xl"
      >
        <p className="text-xs font-bold tracking-[0.25em] uppercase text-[#d4af37] mb-4">Scope of Services</p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase text-slate-100 leading-[0.95]">
          Every Role. <span className="text-stroke-gold">Fully Staffed.</span>
        </h2>
      </motion.div>

      <div data-testid="services-bento-grid" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {services.map((s, i) => (
          <motion.div
            key={s.testid}
            data-testid={s.testid}
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: (i % 3) * 0.1, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ y: -6 }}
            className={`${s.span} group relative border rounded-sm p-7 sm:p-8 overflow-hidden transition-colors duration-500 ${
              s.featured
                ? "bg-gradient-to-br from-[#1e40af]/40 to-[#0d1424] border-[#3b82f6]/40"
                : "bg-[#0d1424] border-white/10 hover:border-[#d4af37]/40"
            }`}
          >
            <div className="absolute top-0 right-0 w-24 h-24 bg-[#d4af37]/5 rotate-45 translate-x-12 -translate-y-12 group-hover:bg-[#d4af37]/15 transition-colors duration-500" />
            <s.icon className={`w-8 h-8 mb-5 ${s.featured ? "text-[#d4af37]" : "text-[#3b82f6]"} group-hover:text-[#d4af37] transition-colors duration-500`} />
            <h3 className="font-display text-2xl font-bold uppercase text-slate-100 leading-tight">{s.title}</h3>
            <p className="mt-3 text-sm text-slate-400 leading-relaxed">{s.desc}</p>
            {s.featured && (
              <span className="inline-block mt-5 text-[10px] font-bold tracking-[0.2em] uppercase bg-[#d4af37]/15 text-[#d4af37] border border-[#d4af37]/30 px-2.5 py-1.5 rounded-sm">
                Primary Focus
              </span>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
